/**
 * @module components\common-component\ResponsePopup
 */
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  name: 'ResponsePopup',
})
export default class ResponsePopup extends Vue {
  @Prop(Boolean) open: boolean | false;
  @Prop(String) response: string | '';
  /* variables */
  dialog: boolean = this.open;
  message: string = this.response;

  closeDialog() {
    this.dialog = false;
    this.$router.push({ name: 'ViewStatus' });
    //Google Analytics
    this.$gtag.event('click',{
      event_category: `SelfCare`,
      event_label: 'Close Dialog'
    });
  }
}
